export const columnDictionary: Record<string, string> = {
  accessToken: 'Token de Acesso',
  acquisitionCost: 'Custo de Aquisição',
  actions: 'Ações',
  activedDays: 'Funcionamento',
  additionalDeadline: 'Prazo Adicional',
  address: 'Endereço',
  addressId: 'Endereço',
  adminUser: 'Usuário Administrador',
  aggregateCost: 'Custo Agregado',
  aisi: 'AISI',
  aliquota: 'Alíquota',
  aliquotaCBS: 'Alíquota CBS',
  aliquotaCOFINS: 'Alíquota COFINS',
  aliquotaIBS: 'Alíquota IBS',
  aliquotaICMS: 'Alíquota ICMS',
  aliquotaIPI: 'Alíquota IPI',
  aliquotaPIS: 'Alíquota PIS',
  allocation: 'Alocação',
  allowCardCreation: 'Permite Criação de Cartão',
  allowedInInvoice: 'Permitido na Nota Fiscal',
  allowManualMove: 'Permite Movimentação Manual',
  approvalId: 'Aprovação',
  approved: 'Aprovado',
  approverId: 'Aprovador',
  archived: 'Arquivado',
  areaId: 'Área',
  astm: 'ASTM',
  ativo: 'Ativo',
  authorId: 'Autor',
  automationId: 'Automação',
  availableBalance: 'Saldo Disponível',
  backImageId: 'Imagem Traseira',
  baseCalculoICMS: 'Base de Cálculo ICMS',
  baseCalculoISS: 'Base de Cálculo ISS',
  baseDeCalculo: 'Base de Cálculo',
  beneficiamentoNoteId: 'Nota de Beneficiamento',
  billingDate: 'Data de Faturamento',
  bodyType: 'Tipo de Carroceria',
  brand: 'Marca',
  breakHour: 'Horário de Intervalo',
  businessUnit: 'Unidade de Negócio',
  capacity: 'Capacidade',
  capacityAmount: 'Quantidade de Capacidade',
  capacityPeriod: 'Período de Capacidade',
  carrierCode: 'Código da Transportadora',
  category: 'Categoria',
  categoryId: 'Categoria',
  cause: 'Causa',
  cep: 'CEP',
  certificadoNome: 'Nome do Certificado',
  certificadoVencimento: 'Vencimento do Certificado',
  certificateId: 'Certificado',
  certificateNumber: 'Número do Certificado',
  certificates: 'Certificados',
  certificateTypeId: 'Tipo de Certificado',
  certificateUrl: 'Certificados',
  cfop: 'CFOP',
  cfopId: 'CFOP',
  changedAt: 'Alterado em',
  changedById: 'Alterado por',
  characteristic: 'Característica',
  chaveAcesso: 'Chave de Acesso',
  checklistItemId: 'Item do Checklist',
  city: 'Cidade',
  cityId: 'Cidade',
  class: 'Condição',
  classificacaoTributaria: 'Classificação Tributária',
  clientId: 'Cliente',
  clientIdentification: 'Identificação do Cliente',
  clientOrderNumber: 'Número do Pedido do Cliente',
  closedById: 'Fechado por',
  cnae: 'CNAE',
  cnpj: 'CNPJ',
  code: 'Código',
  codeId: 'Código',
  codeOfOP: 'Código da OP',
  codeOpString: 'Código da OP',
  codigoProduto: 'Código do Produto',
  codigoSH: 'Código SH',
  collection: 'Coleção',
  collectionColorId: 'Cor da Coleção',
  collectionId: 'Coleção',
  color: 'Cor',
  colorId: 'Cor',
  columnId: 'Coluna',
  comissaoAtiva: 'Comissão Ativa',
  comissaoPercentual: 'Percentual de Comissão',
  comment: 'Comentário',
  commentId: 'Comentário',
  commission: 'Comissão',
  company: 'Empresa',
  companyClientId: 'Empresa Cliente',
  companyDestination: 'Empresa de Destino',
  companyEmissorId: 'Empresa Emissora',
  companyId: 'Empresa',
  companyName: 'Nome da Empresa',
  companyTransportadoraId: 'Transportadora',
  companyTypeId: 'Tipo de Empresa',
  companyTypes: 'Tipo',
  competenceDate: 'Data de Competência',
  competenceValue: 'Valor de Competência',
  complement: 'Complemento',
  completed: 'Concluído',
  completedAt: 'Concluído em',
  conditions: 'Condições',
  consumptionPerPiece: 'Consumo por Peça',
  contactEmail: 'E-mail do Contato',
  contactId: 'Contato',
  contactName: 'Nome do Contato',
  contactPhone: 'Telefone do Contato',
  contacts: 'Contatos',
  contribuinteIcms: 'Contribuinte ICMS',
  correction: 'Correção',
  cost: 'Custo',
  costCharged: 'Custo Cobrado',
  costPerHour: 'Custo por Hora',
  costPerUnit: 'Custo por Unidade',
  countryName: 'País',
  coverFileId: 'Capa',
  coverGeneralFileId: 'Capa',
  cpf: 'CPF',
  createdAt: 'Data de Criação',
  createdByIdUser: 'Criado por',
  criticalAnalysis: 'Análise Crítica',
  criticalAnalysisDesc: 'Descrição da Análise Crítica',
  cstIBS_CBS: 'CST IBS/CBS',
  cstIbsCbsId: 'CST IBS/CBS',
  cstICMS: 'CST ICMS',
  cstIPI: 'CST IPI',
  cstPIS_COFINS: 'CST PIS/COFINS',
  cubage: 'Cubagem',
  currentFreightId: 'Frete Atual',
  currentStock: 'Estoque Atual',
  customerCompanyId: 'Empresa Cliente',
  cutterId: 'Cortador',
  dadosAdicionais: 'Dados Adicionais',
  dataAutorizacao: 'Data de Autorização',
  date: 'Data',
  dateTime: 'Data e Hora',
  dayOfWeek: 'Dia da Semana',
  deadline: 'Prazo',
  deadlineInDays: 'Prazo (dias)',
  deadlines: 'Prazos',
  dealPeriod: 'Período da Negociação',
  decidedAt: 'Decidido em',
  defaultSupplierCompanyId: 'Fornecedor Padrão',
  deletedAt: 'Excluído em',
  deliveryCompanyId: 'Empresa de Entrega',
  deliveryDate: 'Data de Entrega',
  deliveryTime: 'Horário de Entrega',
  density: 'Densidade',
  descount: 'Desconto',
  descricao: 'Descrição',
  descricaoProduto: 'Descrição do Produto',
  descricaoServico: 'Descrição do Serviço',
  description: 'Descrição',
  detail: 'Detalhe',
  diameter: 'Diâmetro',
  diasOffset: 'Dias de Offset',
  diferencialAliquota: 'Diferencial de Alíquota',
  dimension: 'Dimensão',
  dimension1: 'Dimensão 1',
  dimension2: 'Dimensão 2',
  din: 'DIN',
  dreLineId: 'Linha do DRE',
  dressmakerId: 'Costureira',
  dueDate: 'Data de Vencimento',
  email: 'E-mail',
  empresaId: 'Empresa',
  enderecoEntregaId: 'Endereço de Entrega',
  endHour: 'Hora Final',
  endTime: 'Hora de Término',
  enteredAt: 'Entrada em',
  entryId: 'Lançamento',
  error: 'Erro',
  especieTipo: 'Espécie/Tipo',
  eventId: 'Evento',
  executedAt: 'Executado em',
  executeDate: 'Data de Execução',
  executionTime: 'Tempo de Execução',
  exitedAt: 'Saída em',
  expectedDeliveryDate: 'Previsão de Entrega',
  expiresAt: 'Expira em',
  externalId: 'ID Externo',
  extraInfo: 'Informações Extras',
  fabrication: 'Fabricação',
  fabricationId: 'Fabricação',
  factory: 'Fábrica',
  family: 'Família',
  familyId: 'Família',
  fashionOrderId: 'Pedido',
  fashionProductId: 'Produto',
  fileId: 'Arquivo',
  fileName: 'Nome do Arquivo',
  fileSize: 'Tamanho do Arquivo',
  fileUrl: 'URL do Arquivo',
  finalCost: 'Custo Final',
  finalDateOfDelivery: 'Data Final de Entrega',
  finalPrice: 'Preço Final',
  financialEntryItemId: 'Item do Lançamento',
  finishing: 'Acabamento',
  finishingId: 'Acabamento',
  format: 'Formato',
  formatId: 'Formato',
  freight: 'Frete',
  freightId: 'Frete',
  frontImageId: 'Imagem Frontal',
  generalClassId: 'Classe Geral',
  generalFileId: 'Arquivo',
  gradeId: 'Grade',
  graduation: 'Graduação',
  groupId: 'Grupo',
  heatNumber: 'Número da Corrida',
  heatNumberId: 'Número da Corrida',
  heatTreatment: 'Tratamento Térmico',
  heatTreatmentId: 'Tratamento Térmico',
  heatTreatments: 'Tratamentos Térmicos',
  height: 'Altura',
  hex: 'Hexadecimal',
  icms: 'ICMS',
  id: 'ID',
  idealMeasurements: 'Medidas Ideais',
  index: 'Índice',
  indexInOrder: 'Índice no Pedido',
  initHour: 'Hora Inicial',
  installmentNumber: 'Número da Parcela',
  integratedWithOmie: 'Integrado com Omie',
  invoice: 'Nota Fiscal',
  invoiceId: 'Nota Fiscal',
  invoiceNumber: 'Número da Nota Fiscal',
  ipi: 'IPI',
  isActivated: 'Disponível',
  isActive: 'Ativo',
  isInternalService: 'Serviço Interno',
  isMain: 'Principal',
  isPause: 'Pausa',
  isPrincipal: 'Principal',
  isRequired: 'Obrigatório',
  IsSetup: 'Setup',
  isVerificationEnabled: 'Verificação Habilitada',
  itemColorId: 'Cor do Item',
  itemPrice: 'Preço do Item',
  key: 'Chave',
  kitIndex: 'Índice do Kit',
  leadTimeDays: 'Lead Time (dias)',
  length: 'Comprimento',
  lengthInMm: 'Comprimento (mm)',
  linkDanfe: 'Link da DANFE',
  linkedUserId: 'Usuário Vinculado',
  linkedUsers: 'Usuários Vinculados',
  linkXml: 'Link do XML',
  locationId: 'Localização',
  lockedAt: 'Bloqueado em',
  machineId: 'Máquina',
  maintenanceName: 'Nome da Manutenção',
  manufacturer: 'Fabricante',
  marketCost: 'Custo de Mercado',
  markup: 'Markup',
  material: 'Material',
  materialId: 'Material',
  max: 'Máximo',
  maximumBillingAmount: 'Faturamento Máximo',
  maxStock: 'Estoque Máximo',
  measureTypeId: 'Tipo de Medida',
  mimeType: 'Tipo de Arquivo',
  min: 'Mínimo',
  minOrderQuantity: 'Quantidade Mínima de Pedido',
  minStock: 'Estoque Mínimo',
  model: 'Modelo',
  module: 'Módulo',
  moduleType: 'Tipo de Módulo',
  motivoStatus: 'Motivo do Status',
  name: 'Nome',
  nbs: 'NBS',
  nbsId: 'NBS',
  ncm: 'NCM',
  ncmId: 'NCM',
  neighborhood: 'Bairro',
  neighborhoodId: 'Bairro',
  newLengthInMm: 'Novo Comprimento (mm)',
  newQuantity: 'Nova Quantidade',
  newTotalWeight: 'Novo Peso Total',
  newValue: 'Novo Valor',
  nextForecastDate: 'Próxima Previsão',
  nf: 'Nota Fiscal',
  nome: 'Nome',
  nomeCustomizado: 'Nome Customizado',
  norm: 'Norma',
  npc: 'NPC',
  number: 'Número',
  numero: 'Número',
  numeroNF: 'Número da NF',
  numeroParcela: 'Número da Parcela',
  observation: 'Observação',
  observations: 'Observações',
  occurrenceId: 'Ocorrência',
  offeredProduct: 'Produto Ofertado',
  oldLengthInMm: 'Comprimento Anterior (mm)',
  oldQuantity: 'Quantidade Anterior',
  oldTotalWeight: 'Peso Total Anterior',
  oldValue: 'Valor Anterior',
  operationNumber: 'Número da Operação',
  orderDate: 'Data do Pedido',
  orderId: 'Pedido',
  orderItemId: 'Item do Pedido',
  orderName: 'Nome do Pedido',
  orderNumber: 'Número do Pedido',
  orderSituationId: 'Situação do Pedido',
  orderTypeId: 'Tipo de Pedido',
  origemCST: 'Origem CST',
  origin: 'Origem',
  originalName: 'Nome Original',
  originCountry: 'País de Origem',
  originCountryId: 'País de Origem',
  others: 'Outros',
  pantoneCode: 'Código Pantone',
  pantoneId: 'Pantone',
  paramId: 'Parâmetro',
  parentId: 'Pai',
  parentServiceId: 'Serviço Pai',
  payerCompanyId: 'Pagador',
  paymentConditionId: 'Condição de Pagamento',
  paymentMethodId: 'Forma de Pagamento',
  periodicityUnit: 'Unidade de Periodicidade',
  periodicityValue: 'Valor de Periodicidade',
  periodicMaintenanceId: 'Manutenção Periódica',
  permissions: 'Permissões',
  pesoBrutoTransportado: 'Peso Bruto Transportado',
  pesoLiquido: 'Peso Líquido',
  phone: 'Telefone',
  picture: 'Foto',
  piecesQuantity: 'Quantidade de Peças',
  pipelineId: 'Pipeline',
  placaVeiculo: 'Placa do Veículo',
  plate: 'Placa',
  ploomesOrderId: 'ID do Pedido (Ploomes)',
  ploomesProductName: 'Produto (Ploomes)',
  position: 'Posição',
  price: 'Preço',
  priceKg: 'Preço por Kg',
  priceKgMin: 'Preço Mínimo por Kg',
  prices: 'Conjunto de Preço',
  priority: 'Prioridade',
  productCode: 'Código do Produto',
  productId: 'Produto',
  productionDay: 'Dia de Produção',
  productionId: 'Produção',
  productionPace: 'Ritmo de Produção',
  productScript: 'Roteiro do Produto',
  profileId: 'Perfil',
  project: 'Projeto',
  protocolo: 'Protocolo',
  purchaseDemandId: 'Demanda de Compra',
  purchaseMaterialId: 'Material de Compra',
  purchaseOrder: 'Ordem de Compra',
  purchaseOrderId: 'Ordem de Compra',
  purchaseOrderNumber: 'Número da Ordem de Compra',
  purchasePotentialAmount: 'Potencial de Compra',
  qrCodeData: 'QR Code',
  quantidade: 'Quantidade',
  quantidadeTransportada: 'Quantidade Transportada',
  quantities: 'Conjunto de Quantidades',
  quantity: 'Quantidade',
  quantityForThisProduction: 'Quantidade para Produção',
  quantityItems: 'Quantidade de Itens',
  quantityPieces: 'Quantidade de Peças',
  quantityRequired: 'Quantidade Necessária',
  quantityToBuy: 'Quantidade a Comprar',
  rawMaterialName: 'Código',
  readyToShip: 'Pronto para Envio',
  receivedDate: 'Data de Recebimento',
  receiverCompanyId: 'Recebedor',
  recordedAt: 'Registrado em',
  recurrence: 'Recorrência',
  referenceProduct: 'Produto de Referência',
  relevant: 'Relevante',
  representativeId: 'Representante',
  requestedProduct: 'Produto Solicitado',
  requiredQualification: 'Qualificação Necessária',
  requiredQuantity: 'Quantidade Necessária',
  resourceCategoryId: 'Categoria do Insumo',
  resourceId: 'Insumo',
  resourceSupplierCompanyId: 'Fornecedor do Insumo',
  resourceTypeId: 'Tipo de Insumo',
  responsible: 'Responsável',
  responsibleId: 'Responsável',
  restriction: 'Restrição',
  result: 'Resultado',
  returnHour: 'Hora de Retorno',
  routeId: 'Rota',
  saleNumberPloomes: 'Número da Venda (Ploomes)',
  saleStatus: 'Status da Venda',
  scope: 'Escopo',
  scriptId: 'Roteiro',
  scriptMaterialId: 'Material do Roteiro',
  scriptResourceId: 'Insumo do Roteiro',
  sectorId: 'Setor',
  segment: 'Segmento',
  sellerId: 'Vendedor',
  sellingPrice: 'Preço de Venda',
  sequencialLoteNFe: 'Sequencial do Lote NFe',
  sequencialNFe: 'Sequencial NFe',
  sequentialFlow: 'Fluxo Sequencial',
  serie: 'Série',
  serieNFe: 'Série NFe',
  serviceCategoryId: 'Categoria do Serviço',
  serviceId: 'Serviço',
  serviceStageId: 'Etapa do Serviço',
  serviceSupplierCompanyId: 'Fornecedor do Serviço',
  serviceTypeId: 'Tipo de Serviço',
  set: 'Conjunto',
  setupTime: 'Tempo de Setup',
  shelf: 'Prateleira',
  shelfId: 'Prateleira',
  shippingTypeId: 'Tipo de Frete',
  shippingValue: 'Valor do Frete',
  showOnCard: 'Exibir no Cartão',
  sideImageId: 'Imagem Lateral',
  size: 'Tamanho',
  sizes: 'Tamanhos',
  skillId: 'Habilidade',
  stageId: 'Etapa',
  standard: 'Padrão',
  standardsMet: 'Normas Atendidas',
  startDate: 'Data de Início',
  startDateOfDelivery: 'Data Inicial de Entrega',
  startedAt: 'Iniciado em',
  startingMaterial: 'Material Inicial',
  startTime: 'Hora de Início',
  state: 'Estado',
  stateId: 'Estado',
  stateRegistration: 'Inscrição Estadual',
  status: 'Status',
  step: 'Etapa',
  stepId: 'Etapa',
  stepName: 'Nome da Etapa',
  stepType: 'Tipo de Etapa',
  stockId: 'Estoque',
  stockLocation: 'Localização no Estoque',
  stockLocationId: 'Localização no Estoque',
  stockStatus: 'Status',
  stockStreet: 'Rua do Estoque',
  stockStreetId: 'Rua do Estoque',
  stockUnit: 'Unidade de Estoque',
  street: 'Rua',
  structureId: 'Estrutura',
  subModule: 'Submódulo',
  substituicaoTributaria: 'Substituição Tributária',
  subTitle: 'Subtítulo',
  subtotal: 'Subtotal',
  supplier: 'Fornecedor',
  supplierCode: 'Código do Fornecedor',
  supplierCompanyId: 'Fornecedor',
  supplierId: 'Fornecedor',
  suppliers: 'Fornecedores',
  tagId: 'Tag',
  taxConfigId: 'Configuração Fiscal',
  taxes: 'Impostos',
  taxScenarioId: 'Cenário Fiscal',
  thickness: 'Espessura',
  ticketId: 'Ticket',
  time: 'Hora',
  title: 'Título',
  tolerance: 'Tolerância',
  total: 'Total',
  totalCmc: 'Total CMC',
  totalConsumption: 'Consumo Total',
  totalCost: 'Custo Total',
  totalPrice: 'Preço Total',
  totalQuantity: 'Quantidade Total',
  totalValue: 'Valor Total',
  totalWeight: 'Peso Total',
  trackingCode: 'Código de Rastreamento',
  trackingNumber: 'Número de Rastreamento',
  trackingNumberId: 'Número de Rastreamento',
  type: 'Tipo',
  typeId: 'Tipo',
  typeName: 'Nome do Tipo',
  uf: 'UF',
  unitCost: 'Custo Unitário',
  unitOfMeasurementId: 'Unidade de Medida',
  unitPrice: 'Preço Unitário',
  unitQuantity: 'Quantidade',
  uns: 'UNS',
  updatedAt: 'Data de Atualização',
  updatedByIdUser: 'Atualizado por',
  uploadedAt: 'Enviado em',
  urgency: 'Urgência',
  url: 'URL',
  usedQuantity: 'Quantidade Utilizada',
  usedUnitOfMeasurement: 'Unidade de Medida Utilizada',
  userId: 'Usuário',
  userMentionedId: 'Usuário Mencionado',
  valor: 'Valor',
  valorCBS: 'Valor CBS',
  valorCofins: 'Valor COFINS',
  valorIBS: 'Valor IBS',
  valorICMS: 'Valor ICMS',
  valorIPI: 'Valor IPI',
  valorISS_Recolher: 'Valor ISS a Recolher',
  valorParcela: 'Valor da Parcela',
  valorPis: 'Valor PIS',
  valorTotal: 'Valor Total',
  valorTotalNota: 'Valor Total da Nota',
  valorUnitario: 'Valor Unitário',
  value: 'Valor',
  vehicleId: 'Veículo',
  vencimento: 'Vencimento',
  verificationUnit: 'Unidade de Verificação',
  verificationValue: 'Valor de Verificação',
  viewed: 'Visualizado',
  weight: 'Peso',
  width: 'Largura',
  year: 'Ano',
}

const humanizeField = (field: string): string => {
  const spaced = field
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
  return spaced.charAt(0).toUpperCase() + spaced.slice(1)
}

export const getColumnLabel = (field: string): string => {
  return columnDictionary[field] ?? humanizeField(field)
}
